exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.game-header[data-v-78f9a78c] {\n  padding: 6px;\n  height: 60px;\n}\n.backarrowDiv[data-v-78f9a78c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-78f9a78c] {\n  margin: auto;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/game-header.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,aAAa;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;CACd","file":"game-header.vue","sourcesContent":["\n.game-header[data-v-78f9a78c] {\n  padding: 6px;\n  height: 60px;\n}\n.backarrowDiv[data-v-78f9a78c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-78f9a78c] {\n  margin: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78f9a78c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Game-new/game-header.vue
// module id = 401
// module chunks = 1 2